import React from 'react';

import T from '@prisjakt/ui-translate';
import DataContainer from '../../../../components/data';
import Loader from '../../../../components/loader';
import PriceHistoryFragment from '../../../product/components/price-history/fragment.graphql';
import CreateAlert from '../../../product-alert/components/create-alert';

import * as S from './styles';

const alertFragment = `
fragment alert on Product {
  alert {
    id
    priceThreshold
    alertType
    priceStep
    storePreference
    storeGradeThreshold
  }
}
`;

const productQuery = `query($id: Int!, $statisticsTime: String) {
  product(id: $id) {
    ...priceHistory
    ...alert
  }
} ${PriceHistoryFragment} ${alertFragment}`;

const AlertEdit = props => {
  const { alert, withoutGraph, close } = props;

  return (
    <DataContainer
      query={productQuery}
      renderLoader={() => <Loader fadeIn />}
      variables={{ id: alert.product.id }}
      render={({ data }) => {
        const product = {
          ...alert.product,
          ...data.product,
        };

        return (
          <S.AlertEdit>
            <h2>
              <T domain="product">alert.title-edit</T>
            </h2>
            <div>
              <p>
                <T domain="product">alert.lead-text</T>
              </p>
              <CreateAlert
                withoutGraph={withoutGraph}
                product={product}
                showCancel={false}
                onCreate={close}
                onRemove={close}
              />
            </div>
          </S.AlertEdit>
        );
      }}
    />
  );
};

export default AlertEdit;
